import {
  SET_NEW_OFFERS,
  SET_OFFERS,
  SET_REWARDS,
  SET_OFFER_MODAL_DATA,
  SET_OFFER_MODAL_STATUS,
  SET_REWARD_MODAL_DATA,
  SET_REWARD_MODAL_STATUS,
  SET_REWARDS_CATALOG,
  // TODO: import action types added later
} from './actions/types'

const INITIAL_STATE = {
  newOffers: [],
  offers: [],
  rewards: [],
  showOfferModal: false,
  offerModalData: {},
  offerModalStatus: null,
  showRewardModal: false,
  rewardModalData: {},
  rewardModalStatus: null,
  rewardsCatalog: [],
}

function setNewOffers(state, action) {
  return {
    ...state,
    newOffers: action.payload.newOffers,
  }
}

function setOffers(state, action) {
  return {
    ...state,
    offers: action.payload.offers,
  }
}

function setRewards(state, action) {
  return {
    ...state,
    rewards: action.payload.rewards,
  }
}

function setOfferModalData(state, action) {
  return {
    ...state,
    offerModalData: action.payload.offerModalData,
  }
}

function setOfferModalStatus(state, action) {
  const { offerModalStatus } = action.payload

  return {
    ...state,
    showOfferModal: offerModalStatus !== null,
    offerModalStatus,
  }
}

function setRewardModalData(state, action) {
  return {
    ...state,
    rewardModalData: action.payload.rewardModalData,
  }
}

function setRewardModalStatus(state, action) {
  const { rewardModalStatus } = action.payload

  return {
    ...state,
    showRewardModal: rewardModalStatus !== null,
    rewardModalStatus,
  }
}

function setRewardsCatalog(state, action) {
  return {
    ...state,
    rewardsCatalog: action.payload.rewardsCatalog,
  }
}

// TODO: reflect state mutator functions for action types added later

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_NEW_OFFERS:
      return setNewOffers(state, action)
    case SET_OFFERS:
      return setOffers(state, action)
    case SET_REWARDS:
      return setRewards(state, action)
    case SET_OFFER_MODAL_DATA:
      return setOfferModalData(state, action)
    case SET_OFFER_MODAL_STATUS:
      return setOfferModalStatus(state, action)
    case SET_REWARD_MODAL_DATA:
      return setRewardModalData(state, action)
    case SET_REWARD_MODAL_STATUS:
      return setRewardModalStatus(state, action)
    case SET_REWARDS_CATALOG:
      return setRewardsCatalog(state, action)
    // TODO: add more action types if necessary
    default:
      break
  }

  return state
}

export default reducer
